export const CONSTANT = {
  LOCAL_STORAGE_LANG_KEY: 'RC_LANG_KEY',
  LANGUAGES: [
    { key: 'en', name: 'english' },
    { key: 'zh', name: 'chinese' },
    { key: 'es', name: 'spanish' },
    { key: 'idn', name: 'indonesia' },
    { key: 'ja', name: 'japanese' },
    { key: 'ru', name: 'russian' },
    { key: 'th', name: 'thai' },
    { key: 'hy', name: 'armenian' },
  ],
  SUUPORTED_LANGUAGES: ['en', 'zh', 'es', 'th', 'idn', 'ja', 'ru', 'hy'],
};
export const DEBUG = true;
